/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ifNotAuthenticated } from '../routeValidation';
import AuthenticationLayout from '@/views/Layout/AuthenticationLayout.vue';
import { ROUTES } from './routes';

const { SEND_UNLOCK_ACCOUNT_MAIL, UNLOCK_ACCOUNT, } = ROUTES;
const UnlockAccount = () =>
  import(/* webpackChunkName: "UnlockAccount" */ '@/views/UnlockAccount/SendUnlockInstructions.vue');

export default {
  path: SEND_UNLOCK_ACCOUNT_MAIL.route,
  component: AuthenticationLayout,
  beforeEnter: ifNotAuthenticated,
  children: [
    {
      path: SEND_UNLOCK_ACCOUNT_MAIL.route,
      name: SEND_UNLOCK_ACCOUNT_MAIL.name,
      component: UnlockAccount,
    },
    {
      path: UNLOCK_ACCOUNT.route,
      name: UNLOCK_ACCOUNT.name,
      component: UnlockAccount,
    }
  ],
};
